var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-select',{attrs:{"value":_vm.status},on:{"change":_vm.onChange}},_vm._l((_vm.statusOpties),function(i,index){return _c('b-select-option',{key:index,attrs:{"value":index}},[_vm._v("\n    "+_vm._s(i.label)+"\n  ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }